// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './eventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './eventName';

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {EventName}
     * @memberof Event
     */
    name: EventName;
    /**
     * A JSON object containing the event details. The structure of this object is not predefined and can vary depending on the event.
     * @type {{ [key: string]: any; }}
     * @memberof Event
     */
    data?: { [key: string]: any; };
}



/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if (json == null) {
        return json;
    }
    return {
        
        'name': EventNameFromJSON(json['name']),
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function EventToJSON(json: any): Event {
    return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(value?: Event | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': EventNameToJSON(value['name']),
        'data': value['data'],
    };
}

